import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css";
import { AuthContext } from "../Context/AuthContext";
import BASE_URL from "../config";

function Login() {

    const navigate = useNavigate();

    const { login } = useContext(AuthContext);

    const [email, setEmail] = useState("");

    const [password, setPassword] = useState("");

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const res = await axios.post(`${BASE_URL}/api/auth/login`, {

                email,

                password,

            });

            login(res.data.token);

            navigate("/admin/dashboard");

        }

        catch (err) {

            alert(err.response?.data?.message || "Login Failed");

        }

    };

   return (
    <div className="login-page">

        <div className="login-box">

            <div className="login-logo">
                <h1>SAH?</h1>
                <p>Admin Dashboard Login</p>
            </div>

            <form className="login-form" onSubmit={handleSubmit}>

                <input
                    type="email"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}
                />

                <input
                    type="password"
                    placeholder="Enter Password"
                    value={password}
                    onChange={(e)=>setPassword(e.target.value)}
                />

                <button className="login-btn" type="submit">
                    Login
                </button>

            </form>

            <div className="login-footer">
                © 2026 SAH? Admin Panel
            </div>

        </div>

    </div>
);

}

export default Login;